import { Link } from 'react-router-dom';
import { publicRoutes } from '@/app/routes';

export function LandingPage() {
  return (
    <div className="cg-auth-wrap" style={{ flexDirection: 'column', gap: 28 }}>
      <div style={{ textAlign: 'center' }}>
        <div className="cg-brand" style={{ justifyContent: 'center', fontSize: '2rem' }}>
          <i className="bi bi-truck-front" />
          TseTsu Карго
        </div>
        <p className="ts-page-sub" style={{ maxWidth: 460, margin: '8px auto 0' }}>
          Олон улсын карго болон дотоодын хүргэлтийг нэг дороос удирдах систем. Илгээмж бүртгэх,
          агуулахаар хянах, нэгтгэн тээвэрлэх, хүргэх, төлбөр тооцох.
        </p>
      </div>
      <div className="ts-flex-row" style={{ gap: 14, flexWrap: 'wrap', justifyContent: 'center' }}>
        <Link to={publicRoutes.login} className="ts-btn ts-btn-primary" style={{ padding: '12px 22px' }}>
          <i className="bi bi-box-seam" /> Карго компани нэвтрэх
        </Link>
        <Link to={publicRoutes.track} className="ts-btn" style={{ padding: '12px 22px' }}>
          <i className="bi bi-search" /> Илгээмж хайх (track)
        </Link>
        <Link to={publicRoutes.portalLogin} className="ts-btn ts-btn-ghost" style={{ padding: '12px 22px' }}>
          <i className="bi bi-person" /> Хэрэглэгчийн булан
        </Link>
      </div>
    </div>
  );
}
